export const WHATSAPP_NUMBER = '971552385552';
export const WHATSAPP_DISPLAY_NUMBER = '+971 55 238 5552';
export const LINKEDIN_URL = 'https://www.linkedin.com/company/jelani-ai-ai-developing-services/';
export const X_URL = 'https://x.com/JelaniAi';
export const INSTAGRAM_URL = 'https://www.instagram.com/jelaniai1/';
export const TIKTOK_URL = 'https://www.tiktok.com/@jelaniai';
export const FACEBOOK_URL = 'https://www.facebook.com/profile.php?id=61587203821468';
export const YOUTUBE_URL = process.env.REACT_APP_YOUTUBE_URL || '';

export const buildWhatsAppUrl = (message = '') => {
  const query = message ? `?text=${encodeURIComponent(message)}` : '';
  return `https://wa.me/${WHATSAPP_NUMBER}${query}`;
};

export const SOCIAL_MEDIA_LINKS = Object.freeze([
  { id: 'linkedin', label: 'LinkedIn', href: LINKEDIN_URL, icon: 'fab fa-linkedin' },
  { id: 'x', label: 'X', href: X_URL, icon: 'fab fa-x-twitter' },
  { id: 'instagram', label: 'Instagram', href: INSTAGRAM_URL, icon: 'fab fa-instagram' },
  { id: 'tiktok', label: 'TikTok', href: TIKTOK_URL, icon: 'fab fa-tiktok' },
  { id: 'facebook', label: 'Facebook', href: FACEBOOK_URL, icon: 'fab fa-facebook-f' }
]);
